import React from 'react'
import PropTypes from 'prop-types'

import { EMPTY_VALUE } from '../constants'

const GooglePlaceLink = ({ googlePlaceId, googleMapsUri }) => {
  if (!googlePlaceId) return EMPTY_VALUE

  return googleMapsUri ? (
    <a href={googleMapsUri} target="_blank" rel="noopener noreferrer">
      {googlePlaceId}
    </a>
  ) : (
    googlePlaceId
  )
}

GooglePlaceLink.propTypes = {
  googlePlaceId: PropTypes.string,
  googleMapsUri: PropTypes.string,
}

GooglePlaceLink.defaultProps = {
  googlePlaceId: undefined,
  googleMapsUri: undefined,
}

export default GooglePlaceLink
